"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Control = void 0;

var tslib_1 = require("tslib");
/* tslint:disable:member-ordering */


var react_1 = tslib_1.__importDefault(require("react"));

var react_event_listener_1 = tslib_1.__importDefault(require("react-event-listener"));

var CertificateUtils_1 = require("../../CertificateUtils");

var PluginSetup_1 = require("./PluginSetup");

var CertificatesProvider_1 = require("../CertificatesProvider");

var CertificatesList_1 = require("../CertificatesList");

var Loader_1 = require("../Loader");

var ErrorComponent_1 = require("./ErrorComponent");

var CertificateProcessor_1 = require("../CertificatesProvider/CertificateProcessor");

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

var Log_1 = require("@skbkontur/plugin-js/lib/common/Log");

var Errors_1 = require("@skbkontur/plugin-js/lib/common/Errors");

var Errors_2 = require("../Errors");

var _isEqual = require("lodash/isEqual");

var _memoize = require("lodash/memoize");

var constants_1 = require("../../utils/constants");

var CertificatesListStats_1 = require("../../utils/CertificatesListStats");

var PluginChecker_1 = require("./PluginChecker");

var NotariusClient_1 = require("../../CertificateUtils/NotariusClient");

var Features_1 = require("./Features");

var configuration_1 = require("../../contexts/configuration");

var cryptoPro_1 = require("../../utils/cryptoPro");

var common_1 = require("../../utils/common");

var dayjs_1 = tslib_1.__importDefault(require("dayjs"));

var Control =
/** @class */
function (_super) {
  tslib_1.__extends(Control, _super);

  function Control(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    _this.userActivityTimeoutId = 0;
    _this.pluginSetup = new PluginSetup_1.PluginSetup();
    _this.log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "Control");

    _this.handleUserActivity = function () {
      window.clearTimeout(_this.userActivityTimeoutId);

      _this.startUserActivityTimer();

      _this.startActivePollings();
    };

    _this.startCertificateFetching = function () {
      var pluginFullInfo = _this.state.pluginFullInfo;

      if (pluginFullInfo) {
        _this.props.trackEvent('pluginVersion', pluginFullInfo.pluginInfo.version);

        _this.onPluginSelect(pluginFullInfo);
      }

      _this.certificatesProvider = new CertificatesProvider_1.CertificatesProvider(tslib_1.__assign(tslib_1.__assign({}, _this.props), {
        ntrClient: _this.ntrClient,
        caCabinetClient: _this.CACabinetClient,
        installParams: _this.props.install ? tslib_1.__assign(tslib_1.__assign({}, _this.props.install), {
          validIssuers: _this.props.validIssuers,
          onStartInternal: _this.onCertInstallStart
        }) : undefined,
        certificateProcessor: _this.certificateProcessor,
        pluginFullInfo: pluginFullInfo && pluginFullInfo.state.ready ? pluginFullInfo : undefined,
        onGetCertificates: _this.processCertificates,
        onError: _this.onError,
        onToolboxFallback: _this.onToolboxFallback
      }));

      _this.certificatesProvider.start();
    };

    _this.onError = function (error) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , this.checkError(error)];

            case 1:
              error = _a.sent();

              if (!this.state.error || error.code !== this.state.error.code) {
                // внешний обработчик ошибки вызываем только если это первая ошибк,
                // либо код ошибки изменился
                if (this.props.onError) {
                  this.props.onError(error);
                }

                this.props.trackEvent('error', error.code, {
                  errorCode: error.code,
                  errorMessage: error.message,
                  details: error.details
                });
                this.log.error(error.message, error);
              }

              this.setState({
                error: error
              });
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    _this.onToolboxFallback = function () {
      var fallback = _this.state.pluginFullInfo.fallback;

      var newPluginFullInfo = tslib_1.__assign(tslib_1.__assign({}, fallback), {
        state: {
          ready: true
        }
      });

      _this.onPluginSelect(newPluginFullInfo);

      _this.setState({
        pluginFullInfo: newPluginFullInfo
      });
    };

    _this.onPluginSelect = function (pluginFullInfo) {
      if (_this.props.onPluginSelect) {
        var plugin = pluginFullInfo.plugin,
            pluginInfo = pluginFullInfo.pluginInfo;

        _this.props.onPluginSelect(plugin, pluginInfo);
      }
    };

    _this.processCertificates = function (items) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var _a, onGetCertificates, onGetAllCertificates, allItems, allVisibleCerts;

        return tslib_1.__generator(this, function (_b) {
          if (items.length) {
            // вызываем внешние обработчики только если получены первые сертификаты
            // либо массив сертификатов изменился
            if (this.state.items === undefined || common_1.isItemsChanged(this.state.items, items)) {
              _a = this.props, onGetCertificates = _a.onGetCertificates, onGetAllCertificates = _a.onGetAllCertificates;

              if (onGetCertificates) {
                onGetCertificates(items.map(function (item) {
                  return item.certificate;
                }), items);
              }

              if (onGetAllCertificates) {
                allItems = this.certificatesProvider.getAllItems();
                allVisibleCerts = this.certificateProcessor.getAllVisibleItems(allItems);
                onGetAllCertificates(allVisibleCerts.map(function (item) {
                  return item.certificate;
                }), allVisibleCerts);
              }
            }

            this.setState({
              items: items,
              error: undefined
            });
            this.certListMetrics(items);
          } else {
            this.onError(new Errors_1.CommonError('No certificates for show', null, Errors_2.DisplayedErrorCodes.NoCertificates));
          }

          return [2
          /*return*/
          ];
        });
      });
    };

    _this.onCertInstallStart = function () {
      var flags = _this.state.pluginFullInfo.flags;
      var captionEnding = !flags.InstallWithoutPasswordRequest ? ' \nВведите пароль, если он будет запрошен' : '';

      _this.setState({
        loaderCaption: "\u041C\u044B \u0443\u0441\u0442\u0430\u043D\u0430\u0432\u043B\u0438\u0432\u0430\u0435\u043C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B." + captionEnding
      });
    };

    _this.printStat = function () {
      var _a = _this.state,
          pluginFullInfo = _a.pluginFullInfo,
          error = _a.error;
      var stats = new CertificatesListStats_1.CertificatesListStats({
        pluginSetupResult: pluginFullInfo,
        error: error,
        certificatesProcessor: _this.certificateProcessor,
        certificatesProvider: _this.certificatesProvider
      });
      stats.print();
    };

    _this.checkError = function (error) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var pluginFullInfo, allItems, validItems, filteredByClient, _a;

        return tslib_1.__generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              pluginFullInfo = this.state.pluginFullInfo;
              if (!(error.code === Errors_2.DisplayedErrorCodes.NoCertificates)) return [3
              /*break*/
              , 4];
              allItems = this.certificatesProvider.getAllItems();
              validItems = this.certificateProcessor.getValidItems(allItems);
              filteredByClient = this.certificateProcessor.getFilteredByClient(allItems);
              if (!filteredByClient.length) return [3
              /*break*/
              , 1];
              error.code = this.props.ignoreNoCertificatesByFilterError === false ? Errors_2.DisplayedErrorCodes.NoCertificatesByFilter : Errors_2.DisplayedErrorCodes.NoValidCertificates;
              return [3
              /*break*/
              , 4];

            case 1:
              _a = pluginFullInfo;
              if (!_a) return [3
              /*break*/
              , 3];
              return [4
              /*yield*/
              , cryptoPro_1.isCryptoProInstalledM(pluginFullInfo.plugin)];

            case 2:
              _a = _b.sent() === false;
              _b.label = 3;

            case 3:
              /**
               * Если pluginFullInfo не undefined (т.е. storeType содержит что-то кроме StoreType.Requisite)
               * и при этом сертификаты не найдены и нет КриптоПро
               * То нужно преложить ему поставить КриптоПро.
               * Определение наличия КриптоПро это асинхронная операция.
               */
              if (_a) {
                error.code = Errors_2.DisplayedErrorCodes.NoCryptoPro;
              } else {
                // Если КриптоПро установлен то выводим сообщения об необходимости поставить сертификаты.
                error.details = tslib_1.__assign({
                  certInstallAvailable: pluginFullInfo && this.props.install && pluginFullInfo.flags.InstallCertificate
                }, error.details); // если подходящие (валидные) сертификаты есть, но видимых нет
                // то ошибка будет NoActiveCertificates, иначе NoValidCertificates

                error.code = validItems.length ? Errors_2.DisplayedErrorCodes.NoActiveCertificates : Errors_2.DisplayedErrorCodes.NoValidCertificates;
              }

              _b.label = 4;

            case 4:
              // Если мы не можем подключиться к Плагину и при этом Плагин не доступен
              // в данной ОС или браузере, то выводим детализированную ошибку
              if (error.code === Errors_2.DisplayedErrorCodes.NoPlugin && pluginFullInfo && pluginFullInfo.pluginAvailableError) {
                error.code = pluginFullInfo.pluginAvailableError.code;
              }

              return [2
              /*return*/
              , error];
          }
        });
      });
    };

    _this.trackEventOnce = _memoize(_this.props.trackEvent, function (_, action, label) {
      return action + ":" + label;
    });

    _this.certListMetrics = function (items) {
      // отправляем метрику если в списке сертификаты на ГОСТ 2012
      var Gost2012L256bit = items.filter(function (_a) {
        var certificate = _a.certificate;
        return certificate.publicKeyAlgorithm() === Plugin_1.PublicKeyAlgorithm.GOSTR3410_2012_256;
      });

      if (Gost2012L256bit.length) {
        _this.trackEventOnce('GOST2012', Plugin_1.PublicKeyAlgorithm.GOSTR3410_2012_256, {
          count: Gost2012L256bit.length
        });
      }

      var Gost2012L512bit = items.filter(function (_a) {
        var certificate = _a.certificate;
        return certificate.publicKeyAlgorithm() === Plugin_1.PublicKeyAlgorithm.GOSTR3410_2012_512;
      });

      if (Gost2012L512bit.length) {
        _this.trackEventOnce('GOST2012', Plugin_1.PublicKeyAlgorithm.GOSTR3410_2012_512, {
          count: Gost2012L512bit.length
        });
      }

      _this.trackEventOnce('VisibleCertsCount', items.length.toString());
    }; // console.time('P_All');
    // console.time('P_PluginSetup');


    _this.ntrClient = new NotariusClient_1.NotariusClient({
      sid: props.sid,
      env: props.env,
      url: props.url,
      headers: props.headers,
      timeout: props.timeout
    });
    _this.CACabinetClient = new CertificateUtils_1.CACabinetClient(); // инициализируем обработчик сертификатов

    _this.certificateProcessor = new CertificateProcessor_1.CertificateProcessor(tslib_1.__assign(tslib_1.__assign({}, props), {
      cabucIssuers: props.CAParams ? props.CAParams.issuers : [],
      visiblePeriodByCAStatus: props.CAParams ? props.CAParams.visiblePeriodByCAStatus : {},
      sortByStatus: props.CAParams ? props.CAParams.sortByStatus : false
    }));

    _this.starter();

    _this.startUserActivityTimer(); // @ts-ignore


    window.__certDiag = _this.printStat; // глобально устанавливаем локализацию для dayjs

    dayjs_1.default.locale('ru');
    return _this;
  }

  Control.prototype.starter = function () {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var onlyPluginCertificates, onlyRequisiteCertificates, _a, pluginFullInfo_1, pluginFullInfo;

      var _this = this;

      return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            onlyPluginCertificates = !this.props.storeTypes.includes(Plugin_1.StoreType.Requisite);
            onlyRequisiteCertificates = this.props.storeTypes.includes(Plugin_1.StoreType.Requisite) && this.props.storeTypes.length === 1;
            _a = true;

            switch (_a) {
              case onlyPluginCertificates:
                return [3
                /*break*/
                , 1];

              case onlyRequisiteCertificates:
                return [3
                /*break*/
                , 3];
            }

            return [3
            /*break*/
            , 4];

          case 1:
            return [4
            /*yield*/
            , this.pluginSetup.getPluginFullInfo({
              supportedOperationSystems: this.props.supportedOperationSystems,
              unsupportedBrowsers: this.props.unsupportedBrowsers,
              toolboxBrowsers: this.props.toolboxBrowsers,
              minPluginVersion: this.props.minPluginVersion
            })];

          case 2:
            pluginFullInfo_1 = _b.sent();
            this.setState({
              pluginFullInfo: pluginFullInfo_1
            });

            if (pluginFullInfo_1.state.ready) {
              this.startCertificateFetching();
            } else {
              if (pluginFullInfo_1.state.error.code === Errors_2.DisplayedErrorCodes.ObsoletePluginVersion) {
                this.onError(pluginFullInfo_1.state.error);
              } else {
                this.pluginChecker = new PluginChecker_1.PluginChecker({
                  plugin: pluginFullInfo_1.plugin,
                  period: this.props.pluginCheckPeriod,
                  onError: this.onError,
                  onComplete: function onComplete(pluginInfo) {
                    // плагин "заработал", обновляем информацию о нем в state компонента.
                    pluginFullInfo_1.pluginInfo = pluginInfo;
                    pluginFullInfo_1.state = {
                      ready: true
                    };
                    pluginFullInfo_1.flags = Features_1.getFeatureFlags(pluginInfo.version);

                    _this.setState({
                      pluginFullInfo: pluginFullInfo_1
                    }, _this.startCertificateFetching);
                  }
                });
                this.pluginChecker.start();
              }
            }

            return [3
            /*break*/
            , 6];

          case 3:
            {
              this.startCertificateFetching();
              return [3
              /*break*/
              , 6];
            }
            _b.label = 4;

          case 4:
            return [4
            /*yield*/
            , this.pluginSetup.getPluginFullInfo({
              supportedOperationSystems: this.props.supportedOperationSystems,
              unsupportedBrowsers: this.props.unsupportedBrowsers,
              toolboxBrowsers: this.props.toolboxBrowsers,
              minPluginVersion: this.props.minPluginVersion
            })];

          case 5:
            pluginFullInfo = _b.sent();
            this.setState({
              pluginFullInfo: pluginFullInfo
            }, this.startCertificateFetching);
            _b.label = 6;

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Control.prototype.startUserActivityTimer = function () {
    var _this = this;

    this.userActivityTimeoutId = window.setTimeout(function () {
      _this.log.info("The period after the last user activity (" + _this.props.userActivityPeriod + "ms) has been expired");

      _this.stopActivePollings();
    }, this.props.userActivityPeriod);
  };

  Control.prototype.stopActivePollings = function () {
    if (this.pluginChecker) {
      this.pluginChecker.stop();
    }

    if (this.certificatesProvider) {
      this.certificatesProvider.stop();
    }
  };

  Control.prototype.startActivePollings = function () {
    if (this.pluginChecker) {
      this.pluginChecker.start();
    }

    if (this.certificatesProvider) {
      this.certificatesProvider.start();
    }
  };

  Control.prototype.render = function () {
    var _this = this;

    var _a = this,
        _b = _a.state,
        error = _b.error,
        pluginFullInfo = _b.pluginFullInfo,
        items = _b.items,
        certificateProcessor = _a.certificateProcessor;

    var loader = items === undefined;
    var content;

    if (error) {
      var onAccessConfirmed = function onAccessConfirmed() {
        if (_this.pluginChecker) {
          _this.log.info('manual restart plugin check');

          _this.pluginChecker.stop();

          _this.pluginChecker.start();
        }
      };

      content = react_1.default.createElement(ErrorComponent_1.ErrorComponent, {
        error: error,
        onAccessConfirmed: onAccessConfirmed
      });
    } else if (loader) {
      content = react_1.default.createElement(Loader_1.Loader, {
        caption: this.state.loaderCaption || 'Загрузка'
      });
    } else {
      // console.timeEnd('P_ProcessCerts');
      // console.time('P_Render');
      // @ts-ignore
      window.renderStart = Date.now();
      content = react_1.default.createElement(CertificatesList_1.CertificatesList, {
        items: items
      });
    }

    return react_1.default.createElement("div", null, react_1.default.createElement(configuration_1.ConfigurationProvider, {
      value: tslib_1.__assign(tslib_1.__assign({}, this.props), {
        pluginFullInfo: pluginFullInfo,
        certificateProcessor: certificateProcessor
      })
    }, react_1.default.createElement(react_event_listener_1.default, {
      target: document,
      onMouseMove: this.handleUserActivity
    }), content));
  };

  Control.prototype.componentWillUnmount = function () {
    this.stopActivePollings();
  };

  Control.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
    var updatedOptions;

    if (!_isEqual(this.props.blacklist, nextProps.blacklist)) {
      updatedOptions = tslib_1.__assign(tslib_1.__assign({}, updatedOptions), {
        blacklist: nextProps.blacklist
      });
    }

    if (!_isEqual(this.props.customFilter, nextProps.customFilter)) {
      updatedOptions = tslib_1.__assign(tslib_1.__assign({}, updatedOptions), {
        customFilter: nextProps.customFilter
      });
    }

    if (this.certificatesProvider && updatedOptions) {
      this.certificateProcessor.updateOptions(updatedOptions);
      this.certificatesProvider.refreshItems();
    }
  };

  return Control;
}(react_1.default.Component);

exports.Control = Control;